function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fe3029a3-875b-4469-98d6-48923f1de75c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "a9b9a56e-8b6b-4ae8-acb9-37a6c6e0cfb9",
    "data-name": "Wave-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b63a524a-a5e0-4e9b-8258-2f4cd3fee096",
    "data-name": "Rectangle-Copy-6",
    d: "M1366,48H0V0C205,0,709,41.77059,1366,41.77059Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave4;